import React from 'react';
import { noAccessCss, glyph, railsInputName } from 'members/helpers';
import Glyph from 'components/glyph';

class PermissionCapabilities extends React.Component {
  render() {
    if (!this.props.isVisible) { return (null); }

    if (this.props.isEditable) {
      return (<EditablePermissionCapabilities
        memberId={this.props.memberId}
        manageMembers={this.props.manageMembers}
        manageBilling={this.props.manageBilling}
        hasLogAccess={this.props.hasLogAccess}
        noAccessCss={noAccessCss}
        glyph={glyph}
        onCheckboxChange={this.props.onCheckboxChange}
        onLogAccessChange={this.props.onLogAccessChange}
      />);
    } else {
      return (<ReadOnlyPermissionCapabilities
        manageMembers={this.props.manageMembers}
        manageBilling={this.props.manageBilling}
        hasLogAccess={this.props.hasLogAccess}
        noAccessCss={noAccessCss}
        glyph={glyph}
      />);
    }
  }
}



// *********************************************************************************
// Functional components
// *********************************************************************************



// responsible for rendering the permission capabilities section of the form
// *********************************************************************************
function EditablePermissionCapabilities(props) {
  return (
    <div className="grid-cell mod-capabilities">
      <h4>Capabilities</h4>
      <p>
        <label>
          <input className="manage-members" type="checkbox" value="1"
            name={railsInputName(props.memberId, 'manage_members')}
            defaultChecked={props.manageMembers}
            onChange={props.onCheckboxChange('manageMembers')}
          /> Manage users and permissions
        </label>
      </p>
      {
        props.manageMembers &&
          <div>
            <p className="full-access-note permissions-note">
              <Glyph name="up-arrow-1" className="lefted" /> This option grants complete access
            </p>
          </div>
      }
      <p>
        <label>
          <input className="manage-billing" type="checkbox" value="1"
            name={railsInputName(props.memberId, 'manage_billing')}
            defaultChecked={props.manageBilling}
            disabled={props.manageMembers}
            onChange={props.onCheckboxChange('manageBilling')}
          /> Change plans and payment
        </label>
      </p>
      <p>
        <label>
          <input className="log-access" type="checkbox" value="1"
            name={railsInputName(props.memberId, 'log_access')}
            defaultChecked={props.hasLogAccess}
            disabled={props.manageMembers}
            onChange={props.onLogAccessChange}
          /> Access to logs
        </label>
      </p>
    </div>
  );
}

// responsible for listing general permission access/capabilities
// *********************************************************************************
function ReadOnlyPermissionCapabilities(props) {
  return (
    <div className="grid-cell mod-capabilities">
      <h4>Capabilities</h4>
      <p className={props.noAccessCss(props.manageMembers)}>
        <Glyph name={props.glyph(props.manageMembers)} /> Manage users and permissions
      </p>
      <p className={props.noAccessCss(props.manageBilling)}>
        <Glyph name={props.glyph(props.manageBilling)} /> Change plans and payment
      </p>
      <p className={props.noAccessCss(props.hasLogAccess)}>
        <Glyph name={props.glyph(props.hasLogAccess)} /> Access to logs
      </p>
    </div>
  );
}

export default PermissionCapabilities;
